/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-dialog-content[_ngcontent-%COMP%]{text-align:center!important}mat-icon[_ngcontent-%COMP%]{vertical-align:middle!important}.price-container[_ngcontent-%COMP%]{padding-left:5%;padding-right:5%;text-align:left}"];
export { styles as styles };
